import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import extLinkIcon from '../../../../assets/images/icons/ext-link.svg';

export const useStyles = makeStyles(({
  fontWeights,
  fontFamilies,
  palette,
  spaceXMin,
}: Theme) => ({
  icon: {
    display: 'block',
    width: '4rem',
    height: '4rem',
    objectFit: 'contain',
    marginBottom: '0.5rem',
  },
  title: {
    marginTop: 0,
    marginBottom: spaceXMin,
    paddingBottom: spaceXMin,
    borderBottom: `2px solid ${palette.primary.light}`,
    color: palette.primary.light,
    fontFamily: fontFamilies.primary,
    fontSize: '1.75rem',
    lineHeight: 1.2,
    fontWeight: fontWeights.regular,
    letterSpacing: -0.59,
  },
  titleTopBorder: {
    paddingTop: spaceXMin,
    paddingBottom: 0,
    borderBottom: 0,
    borderTop: `2px solid ${palette.primary.light}`,
  },
  titleExtLink: {
    position: 'relative',
    paddingRight: '2.25rem',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: spaceXMin,
      display: 'block',
      width: '2rem',
      height: '2rem',
      background: `no-repeat url(${extLinkIcon}) center`,
      backgroundSize: 'contain',
    },
  },
  content: {
    margin: 0,
    color: palette.primary.light,
    fontWeight: 300,
    letterSpacing: -0.32,
  },
  block: {
    display: 'block',
  },
}));
